import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaEnvelope, FaHeart, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Projects', href: '#projects' }
  ];

  const resourceLinks = [
    { name: 'Experience', href: '#experience' },
    { name: 'Certifications', href: '#certifications' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contact', href: '#contact' }
  ];

  const techStack = [
    'React',
    'Framer Motion',
    'React Icons',
    'CSS3'
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="footer-brand">Mudassir Khattak</h3>
            <p className="footer-tagline">Software Quality Assurance Engineer</p>
            <p className="footer-description">
              Ensuring software excellence through comprehensive testing, automation, 
              and performance validation.
            </p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/in/mudassir-sami-594518283" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaLinkedin />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaGithub />
              </a>
              <a href="mailto:maidizone@gmail.com" className="social-icon">
                <FaEnvelope />
              </a>
              <a href="https://wa.me/923431666949" target="_blank" rel="noopener noreferrer" className="social-icon">
                <FaWhatsapp />
              </a>
            </div>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h4>Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(link.href);
                  }}>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4>Resources</h4>
            <ul className="footer-links">
              {resourceLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.href} onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(link.href);
                  }}>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <h4>Tech Stack</h4>
            <p className="tech-description">This portfolio is built with:</p>
            <div className="tech-stack">
              {techStack.map((tech, index) => (
                <span key={index} className="tech-badge">{tech}</span>
              ))}
            </div>
          </motion.div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>
              © {currentYear} Mudassir Khattak - Software Quality Assurance Engineer. 
              All rights reserved.
            </p>
            <p className="made-with">
              Made with <FaHeart className="heart-icon" /> and dedication to quality
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
